export const primary = '#1890ff';
export const primarySemiLight = '#1890ff80';
export const primaryLight = '#1890ff1a';
export const primaryDark = '#0c589e';
export const primaryDrop = '#1890ff4d';
export const primaryHover = '#40a9ff';
export const primaryActive = '#096dd9';

export const clashPrimary = '#d5712d';
export const clashPrimaryLight = '#e8a57a';

export const secondary = '#b51b1b';
export const secondaryHover = '#f35a5a';
export const secondaryActive = '#821212';

export const darkBackground = '#053461';
export const darkBackgroundLight = '#084178';
export const darkBackgroundTransparent = '#05346133';
export const lightBackground = '#f5f5f5';
export const lightWhite = 'rgba(255, 255, 255, 0.7)';
export const lightText = 'rgba(0, 0, 0, 0.45)';
export const defaultText = 'rgba(0, 0, 0, 0.65)';

export const greyBorder = '#d9d9d9';
export const buttonHoverBackground = '#e0dfdf';

export const success = '#1fb31f';
export const error = '#ff4d4f';
export const warning = '#faad14';

// https://material.io/resources/color/  - 600
export const red600 = '#e53935';
export const orange600 = '#fb8c00';
export const deepOrange600600 = '#fb8c00';
export const yellow600 = '#fdd835';
export const green600 = '#7cb342';
export const blue600 = '#1e88e5';
export const cyan600 = '#00acc1';
export const purple600 = '#8e24aa';
export const brown600 = '#6d4c41';
export const black600 = '#484848';

export const lifeTracker = [
  red600,
  orange600,
  yellow600,
  green600,
  blue600,
  purple600,
  brown600,
  black600,
];

// https://material.io/resources/color/  - 300
// new: http://mcg.mbitson.com/#!?mcgpalette0=%23f1c232
export const red300 = '#e57373';
export const pink300 = '#f06292';
export const purple300 = '#ba68c8';
export const blue300 = '#64b5f6';
export const cyan300 = '#4dd0e1';
export const green300 = '#81c784';
export const yellow300 = '#fff176';
export const yellow700 = '#EDB426';
export const orange300 = '#ffb74d';
export const deepOrange300 = '#ff8a65';
export const brown300 = '#a1887f';

export const typeColors = {
  Creature: green300,
  Enchantment: cyan300,
  Artifact: purple300,
  Battle: yellow700,
  Planeswalker: deepOrange300,
  Sorcery: red300,
  Instant: blue300,
  Land: brown300,
};

export const colorPalette = [
  '#e57373',
  '#f06292',
  '#ba68c8',
  '#9575cd',
  '#7986cb',
  '#64b5f6',
  '#4fc3f7',
  '#4dd0e1',
  '#4db6ac',
  '#81c784',
  '#aed581',
  '#dce775',
  '#fff176',
  '#ffd54f',
  '#ffb74d',
  '#ff8a65',
];

export const manaSymbolColors = {
  W: '#fffcd6',
  U: '#aae2fb',
  B: '#ccc2c0',
  R: '#faaa8f',
  G: '#9cd6b0',
  C: '#dc8eed',
};

export const tagColors = [
  {
    name: 'Recursion',
    color: 'gold',
    fill: '#d4b106',
    background: '#fffbe6',
  },
  {
    name: 'Targeted Removal',
    color: 'volcano',
    fill: '#d4380d',
    background: '#ffbb96',
  },
  // {
  //   name: '???',
  //   color: 'red',
  // },
  {
    name: 'Board Wipe',
    color: 'orange',
    fill: '#d46b08',
    background: '#ffd591',
  },
  {
    name: 'Ramp',
    color: 'green',
    fill: '#389e0d',
    background: '#f6ffed',
  },
  {
    name: 'Win Condition',
    color: 'cyan',
    fill: '#08979c',
    background: '#e6fffb',
  },
  {
    name: 'Protection',
    color: 'blue',
    fill: '#096dd9',
    background: '#e6f7ff',
  },
  {
    name: 'Card Advantage',
    color: 'geekblue',
    fill: '#1d39c4',
    background: '#f0f5ff',
  },
  {
    name: 'Tutor',
    color: 'purple',
    fill: '#531dab',
    background: '#f9f0ff',
  },
  {
    name: 'Default',
    color: 'magenta',
    fill: '#c41d7f',
    background: '#fff0f6',
  },
];
